<template>
  <div class="width-100 min-height flex-column align-items-center justify-content-start bg-image bg-white" style="padding: 0 3%">
    <div class="width-100 br-big overflow-h margin-t">
      <van-field
        id="input-field"
        class="width-100"
        style="height: 2rem; line-height: 2rem; padding: 0 5%"
        type="search"
        placeholder="请输入要搜索的标题"
        @keydown.enter="search"
        v-model="searchObj.search"
      />
    </div>
    <div class="width-100 flex-row align-items-center justify-content-end" style="height: 2rem" @click="show = true">
      <div class="fs-mid-sml fm-sh-regular" style="color: #adc3ea">{{ beginTime2 }}</div>
      <div class="fs-mid-sml fm-sh-regular" style="color: #adc3ea">-</div>
      <div class="fs-mid-sml fm-sh-regular" style="color: #adc3ea">{{ endTime2 }}</div>
    </div>
    <div class="width-100 flex-column bg-white align-items-center justify-content-spaceBetween border br-reg" style="padding: 5% 0">
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="padding-right: 5%">
        <div class="flex-row align-items-center justify-content-center">
          <div class="image-left"></div>
          <div class="fs-mid fm-sh-regular margin-ls">数据看板</div>
        </div>
        <div class="flex-row align-items-center justify-content-center">
          <div class="fs-mid-sml fm-sh-regular">稿件总数</div>
          <div class="fm-sh-regular fs-mid margin-l" style="color: #1e67f7">{{ itemDetail.totalCnt }}</div>
        </div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="padding: 0 5%">
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-regular" style="color: #1e67f7">{{ itemDetail.baseCntIn3day }}</div>
          <div class="fs-mid black fm-sh-regular">基础数</div>
        </div>
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-regular" style="color: #f68100">{{ itemDetail.popularCntIn3day }}</div>
          <div class="fs-mid black fm-sh-regular">爆款数</div>
        </div>
        <div class="width-30 flex-column align-items-center justify-content-center">
          <div class="fs-mid-big fm-sh-regular" style="color: #1e67f7">
            {{ itemDetail.readCntIn3day > 10000 ? (itemDetail.readCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.readCntIn3day }}
          </div>
          <div class="fs-mid black fm-sh-regular">阅读量</div>
        </div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="padding: 0 5%; flex-wrap: wrap">
        <div
          class="width-35 flex-row align-items-center justify-content-around br-reg margin-ts"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 5px"
        >
          <div class="good"></div>
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">点赞数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.thumbCntIn3day > 10000 ? (itemDetail.thumbCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.thumbCntIn3day }}
          </div>
        </div>
        <div
          class="width-35 flex-row align-items-center justify-content-around br-reg margin-ts"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 5px"
        >
          <div class="pl"></div>
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">评论数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.commentCntIn3day > 10000 ? (itemDetail.commentCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.commentCntIn3day }}
          </div>
        </div>
        <div
          class="width-35 flex-row align-items-center justify-content-around br-reg margin-ts"
          style="background: linear-gradient(to right, #f3f8ff, #fefeff); padding: 5px 5px"
        >
          <div class="zhuanfa2"></div>
          <div class="fs-sml fm-sh-regular" style="color: #1e67f7">转发数</div>
          <div class="fs-sml fm-sh-regular grey">
            {{ itemDetail.shareCntIn3day > 10000 ? (itemDetail.shareCntIn3day / 10000).toFixed(2) + 'w' : itemDetail.shareCntIn3day }}
          </div>
        </div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="width-100">
      <div
        v-for="(item, key) in list"
        :key="key"
        class="width-100 border bg-white br-reg margin-ts flex-column align-items-center justify-content-spaceBetween position-relative"
        style="padding-top: 5%"
      >
        <div class="width-100 flex-row align-items-center justify-content-start" style="padding: 0 5%">
          <div class="fs-mid-sml fm-sh-regular">
            <span
              v-if="item.trueReadNumsIn3day > 500"
              style="color: #3e80ff; background: #dae8ff; padding: 0 5px"
              class="fs-sml fm-sh-regular margin-rs"
            >
              基础
            </span>
            <span
              v-if="item.trueReadNumsIn3day > 1000"
              style="color: #f68100; background: #ffe3cc; padding: 0 5px"
              class="fs-sml fm-sh-regular margin-rs"
            >
              爆款
            </span>
            {{ item.listTitle }}
          </div>
        </div>
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="padding: 0 5%; flex-wrap: wrap">
          <div class="width-28 flex-row align-items-center justify-content-start br-reg" style="padding: 5px 0">
            <div class="yuedu"></div>
            <div class="fs-sml fm-sh-regular width-45 textAlign-c" style="color: #1e67f7">阅读</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.trueReadNumsIn3day > 10000 ? (item.trueReadNumsIn3day / 10000).toFixed(2) + 'w' : item.trueReadNumsIn3day }}
            </div>
          </div>
          <div class="width-28 flex-row align-items-center justify-content-start br-reg" style="padding: 5px 0">
            <div class="zhuanfa"></div>
            <div class="fs-sml fm-sh-regular width-45 textAlign-c" style="color: #1e67f7">转发</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.shareNumsIn3day > 10000 ? (item.shareNumsIn3day / 10000).toFixed(2) + 'w' : item.shareNumsIn3day }}
            </div>
          </div>
          <!-- <div class="width-28 flex-row align-items-center justify-content-start br-reg" style="padding: 5px 0">            <div class="time"></div>            <div class="fs-sml fm-sh-regular width-45 textAlign-c" style="color: #1e67f7">总时长</div>            <div class="fs-sml fm-sh-regular grey">{{ item.commentCntIn3day }}</div>          </div> -->
          <div class="width-28 flex-row align-items-center justify-content-start br-reg" style="padding: 5px 0">
            <div class="pinglun"></div>
            <div class="fs-sml fm-sh-regular width-45 textAlign-c" style="color: #1e67f7">评论</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.commentNumsIn3day > 10000 ? (item.commentNumsIn3day / 10000).toFixed(2) + 'w' : item.commentNumsIn3day }}
            </div>
          </div>
          <div class="width-28 flex-row align-items-center justify-content-start br-reg" style="padding: 5px 0">
            <div class="dianzan"></div>
            <div class="fs-sml fm-sh-regular width-45 textAlign-c" style="color: #1e67f7">点赞</div>
            <div class="fs-sml fm-sh-regular grey">
              {{ item.thumbNumsIn3day > 10000 ? (item.thumbNumsIn3day / 10000).toFixed(2) + 'w' : item.thumbNumsIn3day }}
            </div>
          </div>
          <div class="width-28"></div>
        </div>
        <div
          class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts margin-bs"
          @click="showItem(item, key)"
          style="padding: 0 5%"
        >
          <div class="fs-sml fm-sh-regular grey">{{ item.publishedAt }}</div>
          <!-- <div class="fs-sml fm-sh-regular grey">详情</div> -->
        </div>
      </div>
    </van-list>
    <!-- <van-overlay :show="show" class="flex-column align-items-center justify-content-end">      <van-calendar v-model="show" type="range" @confirm="onConfirm" />    </van-overlay> -->
    <van-calendar v-model="show" type="range" :min-date="mixDate" :max-date="maxDate" @confirm="onConfirm" />
  </div>
</template>
<script>
import { getArticleStatistic, getArticleList } from '@/api/zhishu';
export default {
  data() {
    return {
      beginTime2: '',
      endTime2: '',
      mixDate: '',
      maxDate: '',
      show: false,
      list: [],
      itemDetail: { baseCntIn3day: '', popularCntIn3day: '', readCntIn3day: '', thumbCntIn3day: '', commentCntIn3day: '', shareCntIn3day: '' },
      searchObj: {
        time: '',
        beginTime: '',
        endTime: '',
        beginTime1: '',
        endTime1: '',
        pageNum: 0,
        pageSize: 10,
        total: '',
        search: ''
      },
      loading: false,
      finished: false,
      columns: [
        { text: '1月', key: 1 },
        { text: '2月', key: 2 },
        { text: '3月', key: 3 },
        { text: '4月', key: 4 },
        { text: '5月', key: 5 },
        { text: '6月', key: 6 },
        { text: '7月', key: 7 },
        { text: '8月', key: 8 },
        { text: '9月', key: 9 },
        { text: '10月', key: 10 },
        { text: '11月', key: 11 },
        { text: '12月', key: 12 }
      ],
      objList: {}
    };
  },
  beforeMount() {
    let date = new Date();
    this.searchObj.beginTime = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) + '-01';
    this.searchObj.endTime = this.$dayjs(date).format('YYYY-MM-DD');
    this.maxDate = new Date();
    this.mixDate = new Date('2020-01-01');
    this.searchObj.beginTime1 = date.getMonth() + 1 + '-01';
    this.searchObj.endTime1 = this.$dayjs(date).format('M-DD');
    this.searchObj.time = date.getMonth() + 1 + '月';
    this.getArticleStatistic();
  },
  watch: {
    'searchObj.beginTime1': {
      deep: true,
      handler(val) {
        this.beginTime2 = val.split('-')[0] + '月' + val.split('-')[1] + '日';
      }
    },
    'searchObj.endTime1': {
      deep: true,
      handler(val) {
        this.endTime2 = val.split('-')[0] + '月' + val.split('-')[1] + '日';
      }
    }
  },
  methods: {
    search() {
      this.objList = {};
      this.loading = true;
      this.finished = false;
      this.searchObj.pageNum = 1;
      this.getChannelArticleStatisticList();
    },
    getArticleStatistic() {
      getArticleStatistic({ beginTime: this.searchObj.beginTime, endTime: this.searchObj.endTime, channelId: this.$route.query.id })
        .then((res) => {
          this.itemDetail = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChannelArticleStatisticList() {
      getArticleList({
        pageNum: this.searchObj.pageNum,
        pageSize: this.searchObj.pageSize,
        beginTime: this.searchObj.beginTime,
        endTime: this.searchObj.endTime,
        search: this.searchObj.search,
        channelId: this.$route.query.id
      })
        .then((res) => {
          this.searchObj.total = res.total;
          let objList = this.objList;
          objList[this.searchObj.pageNum] = res.rows.map((item) => {
            item.show = false;
            item.publishedAt = this.$dayjs(item.publishedAt).format('YYYY-MM-DD');
            return item;
          });
          let list = [];
          for (let key in objList) {
            list = list.concat(objList[key]);
          }
          this.list = list;
          if (res.total < this.searchObj.pageNum * this.searchObj.pageSize) {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    showItem(item, key) {
      this.list = this.list.map((its, index) => {
        if (key == index) {
          its.show = !its.show;
        }
        return its;
      });
    },
    onConfirm(key) {
      this.searchObj.beginTime = this.$dayjs(key[0]).format('YYYY-MM-DD');
      this.searchObj.endTime = this.$dayjs(key[1]).format('YYYY-MM-DD');
      this.searchObj.beginTime1 = this.$dayjs(key[0]).format('M-DD');
      this.searchObj.endTime1 = this.$dayjs(key[1]).format('M-DD');
      this.getArticleStatistic();
      this.show = false;
      this.searchObj.pageNum = 0;
      this.objList = [];
      this.onLoad();
      this.finished = false;
    },
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getChannelArticleStatisticList();
    }
  }
};
</script>
<style scoped>
::v-deep #left .van-circle__text {
  color: #1e67f7;
  font-size: 1rem;
  font-family: sh-sc-bold;
}
::v-deep #right .van-circle__text {
  color: #f68100;
  font-size: 1rem;
  font-family: sh-sc-bold;
}
.bg-image {
  background-image: url('../assets/image/prizeManagement/bg-image.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.title-all {
  background-image: url('../assets/image/luckyDrawDetails/titleall.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.image-left {
  width: 0.375rem;
  height: 1rem;
  background-image: url('../assets/image/luckyDrawDetails/image-left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.qiehuan {
  width: 3rem;
  height: 1rem;
  background-image: url('../assets/image/luckyDrawDetails/qiehuan.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.dianzan {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/dianzan.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.time {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/time.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pinglun {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/pinglun.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.yuedu {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/yuedu.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pl {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/pl.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.zhuanfa {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/zhuanfa.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.zhuanfa2 {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/zhuanfa2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.good {
  width: 0.75rem;
  height: 0.75rem;
  background-image: url('../assets/image/luckyDrawDetails/good.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep #input-field .van-cell {
  padding: 0 5% !important;
}
</style>